import { createSlice } from '@reduxjs/toolkit';
import {ResponseApi} from '../BaseApi';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const UserSpecialPermissionSlice = createSlice({
    name: 'userSpecialPermissionService',
    initialState: {
        getSpecialPermissionAssigned: null,
        countSpecialPermissionAssigned: 0
    },
    reducers: {
        resetGetSpecialPermissionAssigned: (state, action) => {
            state.getSpecialPermissionAssigned = null;
        }
    },
    extraReducers: {
        'userSpecialPermissionService/getSpecialPermissionAssigned/fulfilled': (state, action) => {
            state.getSpecialPermissionAssigned = ResponseApi(action.payload);
        },
        'userSpecialPermissionService/countSpecialPermissionAssigned/fulfilled': (state, action) => {
            state.countSpecialPermissionAssigned = ResponseApi(action.payload);
        }
    },
});

export const { resetGetSpecialPermissionAssigned } = UserSpecialPermissionSlice.actions;

export default UserSpecialPermissionSlice.reducer;
